import mitt from 'mitt';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

var WHITELISTED_METHODS = ['on', 'off', 'emit'];
function prefixMethods(api) {
  if (!api) throw new TypeError("eventbus-js#prefixMethods/error: Cannot prefix API methods");
  var prefixedAPI = WHITELISTED_METHODS.reduce(function (accumulator, methodName) {
    var prefixedMethodName = "$" + methodName;
    if (!(prefixedMethodName in api)) {
      accumulator[prefixedMethodName] = api[methodName];
    }
    return accumulator;
  }, {});
  return prefixedAPI;
}

var mittInstance = /*#__PURE__*/mitt();
var eventBus = /*#__PURE__*/_extends({}, /*#__PURE__*/prefixMethods(mittInstance), mittInstance);
function exposeGlobals() {
  window.eventBus = eventBus;
}

export default eventBus;
export { eventBus, exposeGlobals };
//# sourceMappingURL=eventbus-js.esm.js.map
